import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user-reverse-helmet",
  "use": "user-reverse-helmet-usage",
  "viewBox": "0 0 448 448",
  "content": "<symbol viewBox=\"0 0 448 448\" id=\"user-reverse-helmet\"><path d=\"M381.2 334.8c-6.5-46.8-25.5-88.3-68-94-22 24-53.8 39.3-88.8 39.3s-66.8-15.3-88.8-39.3c-42.5 5.8-61.5 47.3-68 94 34.8 49 92 81.3 156.8 81.3s122.1-32.3 156.8-81.3zM320.5 160c0-53-43-96-96-96s-96 43-96 96 43 96 96 96 96-43 96-96zm128 64c0 123.3-100 224-224 224C100.8 448 .5 347.5.5 224 .5 100.2 100.8 0 224.5 0s224 100.2 224 224z\" /><path d=\"M252.7 48.6l-13.8 53 3.4-66.2c-11.4-5-24.4-5-35.8 0l3.2 66.2-13.8-53c-38.1 9.6-64.2 44.7-62.5 84h182c1.7-39.4-24.5-74.5-62.7-84z\" fill=\"#fff\" stroke=\"#000\" stroke-width=\"5\" stroke-miterlimit=\"10\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user-reverse-helmet.svg
// module id = /mOE
// module chunks = 1